import { render, staticRenderFns } from "./BranchPositions.vue?vue&type=template&id=202603f1&"
import script from "./BranchPositions.vue?vue&type=script&lang=js&"
export * from "./BranchPositions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports